import React from "react"
import "./tax-exempt.scss"
import { useSelector } from 'react-redux'

const TaxExempt = () => {
  const {customerlistData} = useSelector(({customer}) => customer)
  const { storeDetails } = useSelector(({ store }) => store);
  const status = customerlistData?.tax_exempt_status ?? "Pending"
  
  return (
    <div className="tax-exempt-section">
      <h1>Tax Exemption Request</h1>
      <form className="tax-exempt-form form-control">
        <p>
          If you are requesting a <b>tax exemption,</b> please submit the following information along with a copy of your <b>tax exemption certificate </b>to the <b>store email address:</b> <a href={`mailto:${storeDetails?.StoreEmail}`}>{storeDetails?.StoreEmail}</a><br/><br/>
          • Organization&apos;s full legal name<br/>
          • Organization address<br/>
          • Phone number<br/>
          • Website (if available)<br/>
          • Contact person&apos;s name, title, and contact details (phone and/or email)<br/><br/>
          Once your information and certificate are received, the store manager will review and process your request promptly and reach out to you if any additional details are needed.
        </p>
        <div className="form-group status">
         <label htmlFor="taxstatus">Status:</label>
          <span className={
            status?.toLowerCase() === "pending"
              ? "status-text pending"
              : "status-text approved"
          }>{status}</span>
        </div>
      </form>
    </div>
  )
}

export default TaxExempt
